export const VISTAGE_PATH = '/vistage';

export function canonicalizeVistagePath() {
  if (typeof window === 'undefined') return;

  const { pathname, search, hash } = window.location;
  const shouldReplace = pathname !== VISTAGE_PATH || hash === '#value';
  if (!shouldReplace) return;

  const nextHash = hash === '#value' ? '' : hash;
  window.history.replaceState(null, '', `${VISTAGE_PATH}${search}${nextHash}`);
}
